"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var BuildFlow_1 = require("Project/Actions/BluePrint/BuildFlow/BuildFlow");
var PipedriveImport = (function (_super) {
    __extends(PipedriveImport, _super);
    function PipedriveImport(props) {
        var _this = _super.call(this, props) || this;
        _this.renderLoader = function () {
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "circle-loader" })));
        };
        _this.renderAllDealEntries = function () {
            var deals = _this.props.deals;
            if (!deals) {
                return null;
            }
            return (react_1.default.createElement("div", null,
                deals.map(_this.renderDealEntry),
                react_1.default.createElement("button", { className: "sleek select-deals", onClick: _this.onSelect }, "Select")));
        };
        _this.renderDealEntry = function (deal) {
            var onDealSelection = function (event) { return _this.selectDeal(event, deal); };
            var name = "(No associated person)";
            if (deal.person_id) {
                name = deal.person_id.name;
            }
            else if (deal.org_id) {
                name = deal.org_id.name;
            }
            return (react_1.default.createElement("div", { className: "pipedrive-deal", key: deal.title },
                react_1.default.createElement("div", { className: "title" }, deal.title),
                react_1.default.createElement("div", { className: "name" }, name),
                react_1.default.createElement("input", { type: "checkbox", onChange: onDealSelection })));
        };
        _this.selectDeal = function (event, deal) {
            deal._selected = event.target.checked;
        };
        _this.onSelect = function () {
            var selected = [];
            if (_this.props.deals) {
                _this.props.deals.forEach(function (deal) {
                    if (deal._selected) {
                        selected.push(deal);
                    }
                });
            }
            if (selected.length > 0) {
                _this.props.onImported(BuildFlow_1.BlueprintDataSource.Pipedrive, selected);
            }
            else {
                _this.props.onImported(BuildFlow_1.BlueprintDataSource.Pipedrive, null, "Please select at least one deal.");
            }
        };
        return _this;
    }
    PipedriveImport.prototype.render = function () {
        var deals = this.props.deals;
        return (react_1.default.createElement("div", { className: "import pipedrive-import" },
            react_1.default.createElement("div", { className: "description" },
                react_1.default.createElement("h4", { className: "title" }, "Pipedrive"),
                react_1.default.createElement("p", null, "Import deals to create personalised projects for each.")),
            react_1.default.createElement("div", { className: "action" },
                !deals && this.renderLoader(),
                deals && this.renderAllDealEntries())));
    };
    PipedriveImport = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], PipedriveImport);
    return PipedriveImport;
}(react_1.default.Component));
exports.default = PipedriveImport;
